<template>
  <div class="personalMessage">
    <div class="personalMessage_container">
      <div class="personalMessage_header">
        <div class="personalMessage_header_left">
          <div class="personalMessage_schoolIcon">
            <img alt="" src="../assets/imgs/schoolIcon.png"/>
          </div>
        </div>
        <div class="personalMessage_header_right"></div>
      </div>
      <div class="personalMessage_description">
        <div class="personalMessage_description_title">填报说明</div>
        <p>
          ①建议在国际部官网下载word版简历模板，填写完成后，复制粘贴相应内容到填报页面；注意<span style="color: #4190ff">随时保存</span>，避免因编辑时间过长，页面超时失效。
        </p>
        <p>
          ②报名表提交后不能自主修改，如需修改，请致电国际部招生电话<span style="color: #4190ff">6652-6093</span>/<span
          style="color: #4190ff">6652-6123</span>，后台设置后重新提交。
        </p>
        <p>
          ③<span style="color: #4190ff">一模考试</span>出分后，会统一开放信息更新，请及时登陆本系统提交一模成绩。
        </p>
      </div>
      <div class="personalMessage_content">
        <div class="form_title">北师大实验国际部简历系统</div>
        <div class="personalMessage_content_container">
          <el-form ref="form" :labelWidth="labelWidth" :model="form" label-position="left">
            <div class="personalMessage_content_maintitle">学生个人信息</div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_module_message">
                <div>
                  <el-row :gutter="80">
                    <el-col :span="12">
                      <el-form-item :rules="[
                        { required: true, message: '请填写姓名', trigger: 'blur' },
                        { max: 50, message: '姓名长度应在50字以内', trigger: 'blur' },
                      ]" label="姓名：" prop="name">
                        <el-input v-model="form.name" :disabled="disabledForm"></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        { required: true, message: '请选择性别', trigger: 'change' },
                      ]" class="sex" label="性别：" prop="sex">
                        <el-select v-model="form.sex" :disabled="disabledForm" placeholder="请选择">
                          <el-option label="男" value="男"></el-option>
                          <el-option label="女" value="女"></el-option>
                        </el-select>
                      </el-form-item>

                      <div style="display: flex">
                        <el-form-item :rules="[
                          {
                            required: true,
                            message: '请填写户籍所在地',
                            trigger: 'blur',
                          },
                        ]" class="schoolRecordCity" label="户籍所在地" prop="domicile">
                          <el-select v-model="form.domicile" :disabled="disabledForm" placeholder="请选择">
                            <el-option v-for="item in cityList" :key="item.label" :label="item.label"
                                       :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item v-if="form.domicile === '其他'" :rules="[
                          {
                            required: true,
                            message: '请填写户籍所在区县',
                            trigger: 'blur',
                          },
                        ]" class="schoolRecordCityOtherName" label=""
                                      prop="domicileCityOtherName">
                          <el-input v-model="form.domicileCityOtherName" :disabled="disabledForm"
                                    placeholder="户籍所在区县"></el-input>
                          <div v-if="domicileCityOtherNameRules" class="el-form-item__error">
                            请填写户籍所在区具体名称
                          </div>
                        </el-form-item>
                      </div>
                      <el-form-item :rules="[
                        {
                          required: true,
                          message: '请选择是否有资格',
                          trigger: 'blur',
                        },
                      ]" class="qualification" label="北京填报中招志愿" prop="qualification">
                        <el-radio v-model="form.qualification" :disabled="disabledForm" label="1">有资格
                        </el-radio>
                        <el-radio v-model="form.qualification" :disabled="disabledForm" label="2">无资格
                        </el-radio>
                      </el-form-item>
                      <el-form-item :rules="[
                        { required: true, message: '请填写初中学校', trigger: 'blur' },
                      ]" label="初中学校：" prop="juniorHighSchool">
                        <el-input v-model="form.juniorHighSchool" :disabled="disabledForm"></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        { required: true, message: '请填写教育ID号', trigger: 'blur' },
                        { max: 30, message: '教育ID号长度不能超过30', trigger: 'blur' },
                      ]" label="教育ID号：" prop="customId">
                        <el-input v-model="form.customId" :disabled="disabledForm"></el-input>
                      </el-form-item>
                      <el-form-item label="雅思成绩（线下实考）：" prop="ieltsScore">
                        <el-input-number v-model="form.ieltsScore" :disabled="disabledForm" :max="9" :min="0"
                                         :precision="1" :step="0.1"></el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :rules="[
                        {
                          required: true,
                          message: '请上传附件',
                          trigger: 'change',
                        },
                      ]" class="personalPhoto" label="个人证件照：" prop="photo" style="height: 224px">
                        <div v-if="photoPreview" class="photoPreview">
                          <img :src="photoPreview" alt="" height="100%" width="100%"/>
                          <div class="photoPreview_modal">
                            <i class="el-icon-zoom-in" @click="photoDialogVisible = true"></i>
                            <i v-if="!disabledForm" class="el-icon-delete" @click="deletePhoto"></i>
                          </div>
                        </div>
                        <el-upload v-if="!disabledForm" ref="photo" v-model="form.photo" v-loading="photoLoading"
                                   :before-upload="photoBeforeUpload" :http-request="photoUpload"
                                   :limit="1" :show-file-list="false" action="''"
                                   class="upload_container" element-loading-background="rgba(0, 0, 0, 0.8)"
                                   element-loading-spinner="el-icon-loading"
                                   element-loading-text="上传中，请稍等"
                                   list-type="picture-card">
                          <i slot="default" class="el-icon-plus"></i>
                          <div class="el-upload__text">上传照片</div>
                          <div slot="tip" class="el-upload__tip">
                            <p>要求:</p>
                            <p>必须是证件照，底色不限</p>
                            <p>上传格式jpg、jpeg、png</p>
                          </div>
                        </el-upload>
                        <el-dialog :visible.sync="photoDialogVisible">
                          <img :src="photoPreview" alt="" width="100%"/>
                        </el-dialog>
                      </el-form-item>
                      <div style="display: flex">
                        <el-form-item :rules="[
                          {
                            required: true,
                            message: '请选择学校（学籍）所在区',
                            trigger: 'change',
                          },
                        ]" class="schoolRecordCity" label="学校（学籍）所在区" prop="schoolRecordCity">
                          <el-select v-model="form.schoolRecordCity" :disabled="disabledForm" placeholder="请选择">
                            <el-option v-for="item in cityList" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item v-if="form.schoolRecordCity === '110230'" :rules="[
                          {
                            max: 100,
                            message: '户籍所在县区具体名称不能超过100',
                            trigger: 'blur',
                          },
                          {
                            required: true,
                            message: '请填写学校（学籍）所在县区具体名称',
                            trigger: 'blur',
                          },
                        ]" class="schoolRecordCityOtherName" label=""
                                      prop="schoolRecordCityOtherName">
                          <el-input v-model="form.schoolRecordCityOtherName" :disabled="disabledForm"
                                    placeholder="学籍所在区县"></el-input>
                        </el-form-item>
                      </div>
                      <el-form-item label="托福成绩（线下实考）：" prop="toeflScore">
                        <el-input-number v-model="form.toeflScore" :disabled="disabledForm" :max="120" :min="0"
                                         :precision="0"></el-input-number>
                      </el-form-item>
                      <el-form-item label="其他备注" prop="otherRemarks">
                        <el-input v-model="form.otherRemarks" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_maintitle">家庭成员信息</div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_module_message">
                <div class="personalMessage_content_tableList">
                  <div class="personalMessage_content_tableList_header">
                    <div class="personalMessage_content_tableList_header_item table_relation">
                      监护人
                    </div>
                    <div class="personalMessage_content_tableList_header_item table_name">
                      姓名
                    </div>
                    <div class="personalMessage_content_tableList_header_item table_relationship">
                      与本人关系
                    </div>
                    <div class="personalMessage_content_tableList_header_item table_workPoint">
                      工作单位
                    </div>
                    <div class="personalMessage_content_tableList_header_item table_phone">
                      联系电话
                    </div>
                  </div>
                  <div class="personalMessage_content_tableList_data">
                    <div class="personalMessage_content_tableList_data_item table_relation">
                      <div class="personalMessage_content_tableList_data_item_cell">
                        监护人1
                      </div>
                      <div class="personalMessage_content_tableList_data_item_cell">
                        监护人2
                      </div>
                    </div>
                    <div class="personalMessage_content_tableList_data_item table_name">
                      <div
                        class="personalMessage_content_tableList_data_item_cell personalMessage_content_title_required">
                        <el-form-item :rules="[
                          {
                            required: true,
                            message: '请填写监护人1姓名',
                            trigger: 'blur',
                          },
                          {
                            max: 50,
                            message: '监护人1姓名长度应在50字以内',
                            trigger: 'blur',
                          },
                        ]" label="" prop="faName">
                          <el-input v-model="form.faName" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                      <div class="personalMessage_content_tableList_data_item_cell">
                        <el-form-item :rules="[
                          {
                            max: 50,
                            message: '监护人2姓名长度应在50字以内',
                            trigger: 'blur',
                          },
                        ]" label="" prop="maName">
                          <el-input v-model="form.maName" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="personalMessage_content_tableList_data_item table_relationship">
                      <div
                        class="personalMessage_content_tableList_data_item_cell personalMessage_content_title_required">
                        <el-form-item :rules="[
                          {
                            required: true,
                            message: '请选择监护人1与本人关系',
                            trigger: 'blur',
                          },
                        ]" class="table_relationship" label="" prop="relationship1">
                          <el-select v-model="form.relationship1" :disabled="disabledForm" placeholder="请选择">
                            <el-option label="父亲" value="父亲"></el-option>
                            <el-option label="母亲" value="母亲"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>

                      <div class="personalMessage_content_tableList_data_item_cell table_relationship">
                        <el-form-item class="table_relationship" label="" prop="relationship2">
                          <el-select v-model="form.relationship2" :disabled="disabledForm" placeholder="请选择">
                            <el-option label="父亲" value="父亲"></el-option>
                            <el-option label="母亲" value="母亲"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="personalMessage_content_tableList_data_item table_workPoint">
                      <div class="personalMessage_content_tableList_data_item_cell">
                        <el-form-item :rules="[
                          {
                            max: 50,
                            message: '监护人1工作单位长度应在50字以内',
                            trigger: 'blur',
                          },
                        ]" label="" prop="faGongzuoDanwei">
                          <el-input v-model="form.faGongzuoDanwei" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                      <div class="personalMessage_content_tableList_data_item_cell">
                        <el-form-item :rules="[
                          {
                            max: 50,
                            message: '监护人2工作单位长度应在50字以内',
                            trigger: 'blur',
                          },
                        ]" label="" prop="maGongzuoDanwei">
                          <el-input v-model="form.maGongzuoDanwei" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="personalMessage_content_tableList_data_item table_phone">
                      <div
                        class="personalMessage_content_tableList_data_item_cell personalMessage_content_title_required">
                        <el-form-item :rules="[
                          {
                            required: true,
                            message: '请填写监护人1手机号',
                            trigger: 'blur',
                          },
                          {
                            pattern: /^1[0-9]{10}$/,
                            message: '请输入合法的监护人1手机号',
                            trigger: 'blur',
                          },
                        ]" label="" prop="faPhone">
                          <el-input v-model="form.faPhone" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                      <div class="personalMessage_content_tableList_data_item_cell">
                        <el-form-item :rules="[
                          {
                            pattern: /^1[0-9]{10}$/,
                            message: '请输入合法的监护人1手机号',
                            trigger: 'blur',
                          },
                        ]" label="" prop="maPhone">
                          <el-input v-model="form.maPhone" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_maintitle">成绩</div>
            <div class="personalMessage_content_tips">
              <p>
                1.
                各科成绩均填写卷面原始分数，不包含各科综合社会实践活动成绩；计算总分时不包含体育成绩；
              </p>
              <p>
                2.
                区排名与学校排名为必填项，跟据所在区与学校“总分计算方式”和“区分数段”填写即可；若确实无法获得排名，可以先填“0”；
              </p>
              <p>
                3.
                在参加表里列举的考试前，考试成绩及排名部分全部填“0”，考试后请及时在网站上更新成绩。
              </p>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title_min">学考成绩</div>
              <div class="academicExamination">
                <el-form-item :rules="[
                  {
                    required: true,
                    message: '请填写英语听力与口语成绩',
                    trigger: 'blur',
                  },
                ]" class="englishListenAndSpeak" label="英语听力与口语：" prop="englishListenAndSpeak">
                  <el-input v-model="form.englishListenAndSpeak" :disabled="disabledForm"
                            placeholder="满分40分"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">初二下学期期末成绩</div>
              <div class="personalMessage_content_module_message">
                <div class="personalMessage_content_table">
                  <el-table :data="tableData" class="first-table" style="width: 100%">
                    <el-table-column label="">
                      <template>
                        <div class="personalMessage_content_table_score">卷面分</div>
                        <div class="personalMessage_content_table_score_max">满分值</div>
                      </template>
                    </el-table-column>
                    <el-table-column label="语文">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="chinese">
                            <el-input v-model="form.chinese" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxChinese">
                            <el-input v-model="form.maxChinese" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="数学">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="math">
                            <el-input v-model="form.math" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxMath">
                            <el-input v-model="form.maxMath" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :rules="[
                      {
                        required: true,
                        trigger: 'blur',
                        message: '请填写成绩',
                      },
                    ]" label="英语">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="english">
                            <el-input v-model="form.english" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxEnglish">
                            <el-input v-model="form.maxEnglish" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :rules="[
                      {
                        required: true,
                        trigger: 'blur',
                        message: '请填写成绩',
                      },
                    ]" label="物理">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="physics">
                            <el-input v-model="form.physics" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPhysics">
                            <el-input v-model="form.maxPhysics" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="道德与法治">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="politics">
                            <el-input v-model="form.politics" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPolitics">
                            <el-input v-model="form.maxPolitics" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="personalMessage_content_table_score_total">
                  <el-row :gutter="80">
                    <el-col :span="8" class="personalMessage_content_table_score_total_first">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科总分',
                        },
                      ]" label="必考五科总分：" prop="fifth_total">
                        <el-input v-model="form.fifth_total" disabled></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名科目',
                        },
                      ]" label="参与区排名科目：" prop="inner_subject">
                        <el-input v-model="form.inner_subject" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_second">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科学校排名',
                        },
                      ]" label="必考五科学校排名：" prop="fifth_rank">
                        <el-input v-model="form.fifth_rank" :disabled="disabledForm"></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名总分',
                        },
                      ]" label="参与区排名总分：" prop="inner_rank_total">
                        <el-input v-model="form.inner_rank_total" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_third">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写区排名',
                        },
                      ]" label="区排名：" prop="inner_rank">
                        <el-input v-model="form.inner_rank" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">初三上学期期中成绩</div>
              <div class="personalMessage_content_module_message">
                <div class="personalMessage_content_table">
                  <el-table :data="tableData" class="first-table" style="width: 100%">
                    <el-table-column label="">
                      <template>
                        <div class="personalMessage_content_table_score">卷面分</div>
                        <div class="personalMessage_content_table_score_max">满分值</div>
                      </template>
                    </el-table-column>
                    <el-table-column label="语文">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            }
                          ]" label="" prop="chinese1">
                            <el-input v-model="form.chinese1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxChinese1">
                            <el-input v-model="form.maxChinese1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="数学">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="math1">
                            <el-input v-model="form.math1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxMath1">
                            <el-input v-model="form.maxMath1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="英语">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="english1">
                            <el-input v-model="form.english1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxEnglish1">
                            <el-input v-model="form.maxEnglish1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="物理">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="physics1">
                            <el-input v-model="form.physics1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPhysics1">
                            <el-input v-model="form.maxPhysics1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="道德与法治">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="politics1">
                            <el-input v-model="form.politics1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPolitics1">
                            <el-input v-model="form.maxPolitics1" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="personalMessage_content_table_score_total">
                  <el-row :gutter="80">
                    <el-col :span="8" class="personalMessage_content_table_score_total_first">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科总分',
                        },
                      ]" label="必考五科总分：" prop="fifth_total1">
                        <el-input v-model="form.fifth_total1" disabled></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名科目',
                        },
                      ]" label="参与区排名科目：" prop="inner_subject1">
                        <el-input v-model="form.inner_subject1" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_second">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科学校排名',
                        },
                      ]" label="必考五科学校排名：" prop="fifth_rank1">
                        <el-input v-model="form.fifth_rank1" :disabled="disabledForm"></el-input>
                      </el-form-item>

                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名总分',
                        },
                      ]" label="参与区排名总分：" prop="inner_rank_total1">
                        <el-input v-model="form.inner_rank_total1" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_third">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写区排名',
                        },
                      ]" label="区排名：" prop="inner_rank1">
                        <el-input v-model="form.inner_rank1" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">初三上学期期末成绩</div>
              <div class="personalMessage_content_module_message">
                <div class="personalMessage_content_table">
                  <el-table :data="tableData" class="first-table" style="width: 100%">
                    <el-table-column label="">
                      <div style="display: flex; flex-direction: column; gap: 18px">
                        <template>
                          <div class="personalMessage_content_table_score">卷面分</div>
                          <div class="personalMessage_content_table_score_max">
                            满分值
                          </div>
                        </template>
                      </div>
                    </el-table-column>
                    <el-table-column label="语文">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="chinese2">
                            <el-input v-model="form.chinese2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxChinese2">
                            <el-input v-model="form.maxChinese2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="数学">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="math2">
                            <el-input v-model="form.math2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxMath2">
                            <el-input v-model="form.maxMath2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="英语">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="english2">
                            <el-input v-model="form.english2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxEnglish2">
                            <el-input v-model="form.maxEnglish2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="物理">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="physics2">
                            <el-input v-model="form.physics2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPhysics2">
                            <el-input v-model="form.maxPhysics2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="道德与法治">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="politics2">
                            <el-input v-model="form.politics2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPolitics2">
                            <el-input v-model="form.maxPolitics2" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="personalMessage_content_table_score_total">
                  <el-row :gutter="80">
                    <el-col :span="8" class="personalMessage_content_table_score_total_first">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科总分',
                        },
                      ]" label="必考五科总分：" prop="fifth_total2">
                        <el-input v-model="form.fifth_total2" disabled></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名科目',
                        },
                      ]" label="参与区排名科目：" prop="inner_subject2">
                        <el-input v-model="form.inner_subject2" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_second">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科学校排名',
                        },
                      ]" label="必考五科学校排名：" prop="fifth_rank2">
                        <el-input v-model="form.fifth_rank2" :disabled="disabledForm"></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名科目',
                        },
                      ]" label="参与区排名总分：" prop="inner_rank_total2">
                        <el-input v-model="form.inner_rank_total2" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_third">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写区排名',
                        },
                      ]" label="区排名：" prop="inner_rank2">
                        <el-input v-model="form.inner_rank2" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">
                一模考试成绩
                <span
                  class="personalMessage_content_info">一模考试前，一模成绩及排名部分全部填“0”，一模考试后请及时在网站上更新成绩。</span>
              </div>
              <div class="personalMessage_content_module_message">
                <div class="personalMessage_content_table">
                  <el-table :data="tableData" class="first-table" style="width: 100%">
                    <el-table-column label="">
                      <template>
                        <div class="personalMessage_content_table_score">卷面分</div>
                        <div class="personalMessage_content_table_score_max">满分值</div>
                      </template>
                    </el-table-column>
                    <el-table-column label="语文">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="chinese3">
                            <el-input v-model="form.chinese3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxChinese3">
                            <el-input v-model="form.maxChinese3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="数学">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="math3">
                            <el-input v-model="form.math3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxMath3">
                            <el-input v-model="form.maxMath3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="英语">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="english3">
                            <el-input v-model="form.english3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxEnglish3">
                            <el-input v-model="form.maxEnglish3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="物理">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="physics3">
                            <el-input v-model="form.physics3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPhysics3">
                            <el-input v-model="form.maxPhysics3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="道德与法治">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="politics3">
                            <el-input v-model="form.politics3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPolitics3">
                            <el-input v-model="form.maxPolitics3" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="personalMessage_content_table_score_total">
                  <el-row :gutter="80">
                    <el-col :span="8" class="personalMessage_content_table_score_total_first">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科总分',
                        },
                      ]" label="必考五科总分：" prop="fifth_total3">
                        <el-input v-model="form.fifth_total3" disabled></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名科目',
                        },
                      ]" label="参与区排名科目：" prop="inner_subject3">
                        <el-input v-model="form.inner_subject3" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_second">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科学校排名',
                        },
                      ]" label="必考五科学校排名：" prop="fifth_rank3">
                        <el-input v-model="form.fifth_rank3" :disabled="disabledForm"></el-input>
                      </el-form-item>

                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名总分',
                        },
                      ]" label="参与区排名总分：" prop="inner_rank_total3">
                        <el-input v-model="form.inner_rank_total3" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_third">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写区排名',
                        },
                      ]" label="区排名：" prop="inner_rank3">
                        <el-input v-model="form.inner_rank3" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>


            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">
                二模考试成绩
                <span
                  class="personalMessage_content_info">二模考试前，二模成绩及排名部分全部填“0”，二模考试后请及时在网站上更新成绩。</span>
              </div>
              <div class="personalMessage_content_module_message">
                <div class="personalMessage_content_table">
                  <el-table :data="tableData" class="first-table" style="width: 100%">
                    <el-table-column label="">
                      <template>
                        <div class="personalMessage_content_table_score">卷面分</div>
                        <div class="personalMessage_content_table_score_max">满分值</div>
                      </template>
                    </el-table-column>
                    <el-table-column label="语文">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="chinese4">
                            <el-input v-model="form.chinese4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxChinese4">
                            <el-input v-model="form.maxChinese4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="数学">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="math4">
                            <el-input v-model="form.math4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxMath4">
                            <el-input v-model="form.maxMath4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="英语">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="english4">
                            <el-input v-model="form.english4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxEnglish4">
                            <el-input v-model="form.maxEnglish4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="物理">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="physics4">
                            <el-input v-model="form.physics4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPhysics4">
                            <el-input v-model="form.maxPhysics4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="道德与法治">
                      <template #default>
                        <div style="display: flex; flex-direction: column; gap: 18px">
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="politics4">
                            <el-input v-model="form.politics4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                          <el-form-item :rules="[
                            {
                              required: true,
                              trigger: 'blur',
                              message: '请填写成绩',
                            },
                          ]" label="" prop="maxPolitics4">
                            <el-input v-model="form.maxPolitics4" :disabled="disabledForm"></el-input>
                          </el-form-item>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="personalMessage_content_table_score_total">
                  <el-row :gutter="80">
                    <el-col :span="8" class="personalMessage_content_table_score_total_first">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科总分',
                        },
                      ]" label="必考五科总分：" prop="fifth_total4">
                        <el-input v-model="form.fifth_total4" disabled></el-input>
                      </el-form-item>
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名科目',
                        },
                      ]" label="参与区排名科目：" prop="inner_subject4">
                        <el-input v-model="form.inner_subject4" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_second">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写必考五科学校排名',
                        },
                      ]" label="必考五科学校排名：" prop="fifth_rank4">
                        <el-input v-model="form.fifth_rank4" :disabled="disabledForm"></el-input>
                      </el-form-item>

                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写参与区排名总分',
                        },
                      ]" label="参与区排名总分：" prop="inner_rank_total4">
                        <el-input v-model="form.inner_rank_total4" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" class="personalMessage_content_table_score_total_third">
                      <el-form-item :rules="[
                        {
                          required: true,
                          trigger: 'blur',
                          message: '请填写区排名',
                        },
                      ]" label="区排名：" prop="inner_rank4">
                        <el-input v-model="form.inner_rank4" :disabled="disabledForm"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>


            <div class="personalMessage_content_maintitle">其他材料</div>
            <div class="otherDesc">
              <el-form-item :rules="[{ required: true, message: '请填写关键词', trigger: 'blur' }]" label=""
                            label-width="0"
                            prop="otherDesc1">
                <p>1.用三个关键词评价一下自己</p>
                <el-input v-model="form.otherDesc1" :disabled="disabledForm" placeholder="xxx、xxx、xxx"></el-input>
              </el-form-item>
              <el-form-item
                :rules="[{ required: true, message: '请填写', trigger: 'blur'}]"
                label="" label-width="0"
                prop="otherDesc2">
                <p>
                  2.读书可以开拓视野、引发思考。请分门别类列举你读过的书籍或杂志，并选择其中一本印象最深的书，谈谈它给你带来了什么。</p>
                <el-input v-model="form.otherDesc2" :disabled="disabledForm" :placeholder="this.textArea"
                          maxlength="3000"
                          rows="8" show-word-limit
                          type="textarea"></el-input>
              </el-form-item>
              <el-form-item
                :rules="[{ required: true, message: '请填写', trigger: 'blur'}]"
                label="" label-width="0"
                prop="otherDesc3">
                <p>
                  3.请结合初中阶段你最喜欢的电影、音乐会、演出、展览或运动赛事，谈谈它如何影响了你。
                </p>
                <el-input v-model="form.otherDesc3" :disabled="disabledForm" :placeholder="this.textArea"
                          maxlength="3000"
                          rows="8" show-word-limit
                          type="textarea"></el-input>
              </el-form-item>
              <el-form-item
                :rules="[{ required: true, message: '请填写', trigger: 'blur'}]"
                label="" label-width="0"
                prop="otherDesc4">
                <p>4.请分别列举初中阶段，你在学科、体育、艺术等方面获得的主要荣誉。</p>
                <el-input v-model="form.otherDesc4" :disabled="disabledForm" :placeholder="this.textArea"
                          maxlength="3000"
                          rows="8" show-word-limit
                          type="textarea"></el-input>
              </el-form-item>

              <el-form-item
                :rules="[{ required: true, message: '请填写', trigger: 'blur'}]"
                label="" label-width="0"
                prop="otherDesc5">
                <p>
                  5.请结合你的生活学习经历，选择一个感兴趣的问题或现象，论述你是如何利用课内外资源探究这个问题或现象的。
                </p>
                <el-input v-model="form.otherDesc5" :disabled="disabledForm" maxlength="3000" rows="8"
                          show-word-limit type="textarea"></el-input>
              </el-form-item>
              <el-form-item
                :rules="[{ required: true, message: '请填写', trigger: 'blur'}]"
                class="six"
                label=""
                label-width="0" prop="otherDesc6">
                <p>
                  6.如果你想在实验国际部成立或者加入一个社团，你会选择哪一个？
                </p>
                <el-input v-model="form.otherDesc6" :disabled="disabledForm" :placeholder="this.textArea"
                          maxlength="3000"
                          rows="8" show-word-limit
                          type="textarea"></el-input>
              </el-form-item>
              <el-form-item
                :rules="[{ required: true, message: '请填写', trigger: 'blur'}]"
                label=""
                label-width="0"
                prop="otherDesc7">
                <p>7.请给一位你一直想表达感激的人，写一封简短的感谢信。</p>
                <el-input v-model="form.otherDesc7" :disabled="disabledForm" maxlength="3000" rows="8"
                          show-word-limit
                          type="textarea"></el-input>
              </el-form-item>
              <el-form-item
                :rules="[{ required: true, message: '请填写', trigger: 'blur'}]"
                label="" label-width="0"
                prop="otherDesc8">
                <p>
                  8.你是通过什么途径了解实验中学国际部的？实验国际部最吸引你的地方是什么？
                </p>
                <el-input v-model="form.otherDesc8" :disabled="disabledForm" maxlength="3000" rows="8"
                          show-word-limit type="textarea"></el-input>
              </el-form-item>
              <el-form-item
                :rules="[{ required: true, message: '请填写', trigger: 'blur'}]"
                label="" label-width="0"
                prop="otherDesc9">
                <p>9.请给你未来的实验国际部同桌写一张便条，让他更好认识你。</p>
                <el-input v-model="form.otherDesc9" :disabled="disabledForm" maxlength="3000" rows="8" show-word-limit
                          type="textarea"></el-input>
              </el-form-item>
            </div>
            <div v-if="!disabledForm" class="formFooter">
              <el-form-item>
                <el-button class="purple" type="primary" @click="submitForm('form')">提交
                </el-button>
                <el-button class="default" @click="saveForm">保存</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Qs from "qs";
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Col,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Option,
  Progress,
  Radio,
  RadioGroup,
  Row,
  Select,
  Table,
  TableColumn,
} from "element-ui";

Vue.use(Button)
  .use(Row)
  .use(Col)
  .use(Form)
  .use(Input)
  .use(FormItem)
  .use(Select)
  .use(Option)
  .use(RadioGroup)
  .use(Radio)
  .use(CheckboxGroup)
  .use(Checkbox)
  .use(Progress)
  .use(Loading)
  .use(DatePicker)
  .use(Table)
  .use(TableColumn)
  .use(Dialog)
  .use(InputNumber);
export default {
  name: "personalMessage",
  data() {
    return {
      resultDialog: false,
      dealState: null,
      disabledForm: false,
      tableData: [1],
      textArea: "1.\n2.\n3.\n...",
      form: {
        name: "", // 姓名
        sex: "", // 性别
        domicile: "", // 户籍
        domicileCityOtherName: "", //其他
        qualification: "1", // 资格：1有 2无
        juniorHighSchool: "", // 初中学校
        customId: "", // 教育ID
        ieltsScore: "", //雅思
        photo: "", // 个人证件照
        schoolRecordCity: "", // 学校（学籍）所在区
        schoolRecordCityOtherName: "", // 户籍所在区其他名称
        toeflScore: "", // 托福成绩（线下实考）
        otherRemarks: "", //备注
        // 表格
        faName: "", //监护人姓名
        maName: "", //监护人姓名
        faPhone: "", //监护人电话
        maPhone: "", //监护人电话
        faGongzuoDanwei: "", //监护人单位
        maGongzuoDanwei: "", //监护人单位
        relationship2: "", //与本人关系
        relationship1: "", //与本人关系
        // 考试 学考
        englishListenAndSpeak: "", // 英语听力与口语
        // 初二下学期期末成绩
        chinese: "", //语文
        maxChinese: "", //语文满分值
        math: "", //数学
        maxMath: "", //数学满分值
        english: "", //英语
        maxEnglish: "", //英语满分值
        physics: "", //物理
        maxPhysics: "", //物理满分值
        politics: "", //道德与法治
        maxPolitics: "", //道德与法治满分值
        fifth_total: "", //初二下学期必考五科总分
        fifth_rank: "", // 初二下学期必考五科学校排名
        inner_rank: "", // 初二下学期区排名
        inner_subject: "", // 初二下学期参与区排名科目
        inner_rank_total: "", // 初二下学期参与区排名总分

        // 初三上学期期中成绩
        chinese1: "", //语文
        maxChinese1: "", //语文满分值
        math1: "", //数学
        maxMath1: "", //数学满分值
        english1: "", //英语
        maxEnglish1: "", //英语满分值
        physics1: "", //物理
        maxPhysics1: "", //物理满分值
        politics1: "", //道德与法治
        maxPolitics1: "", //道德与法治满分值
        fifth_total1: "", //初三下学期必考五科总分
        fifth_rank1: "", // 初三下学期必考五科学校排名
        inner_rank1: "", // 初三下学期区排名
        inner_subject1: "", // 初三下学期参与区排名科目
        inner_rank_total1: "", // 初三下学期参与区排名总分

        // 初三上学期期末成绩成绩
        chinese2: "", //语文
        maxChinese2: "", //语文满分值
        math2: "", //数学
        maxMath2: "", //数学满分值
        english2: "", //英语
        maxEnglish2: "", //英语满分值
        physics2: "", //物理
        maxPhysics2: "", //物理满分值
        politics2: "", //道德与法治
        maxPolitics2: "", //道德与法治满分值
        fifth_total2: "", //初三下学期必考五科总分
        fifth_rank2: "", // 初三下学期必考五科学校排名
        inner_rank2: "", // 初三下学期区排名
        inner_subject2: "", // 初三下学期参与区排名科目
        inner_rank_total2: "", // 初三下学期参与区排名总分
        // 一模考试
        chinese3: "", //一模语文
        maxChinese3: "", //一模语文满分值
        math3: "", //一模数学
        maxMath3: "", //一模数学满分值
        english3: "", //一模英语
        maxEnglish3: "", //一模英语满分值
        physics3: "", //一模物理
        maxPhysics3: "", //一模物理满分值
        politics3: "", //一模道德与法治
        maxPolitics3: "", //一模道德与法治满分值
        fifth_total3: "", //一模必考五科总分
        fifth_rank3: "", //一模必考五科学校排名
        inner_rank3: "", //一模区排名
        inner_subject3: "", //一模参与区排名科目
        inner_rank_total3: "", //一模参与区排名总分
        // 二模考试
        chinese4: "", //二模语文
        maxChinese4: "", //二模语文满分值
        math4: "", //二模数学
        maxMath4: "", //二模数学满分值
        english4: "", //二模英语
        maxEnglish4: "", //二模英语满分值
        physics4: "", //二模物理
        maxPhysics4: "", //二模物理满分值
        politics4: "", //二模道德与法治
        maxPolitics4: "", //二模道德与法治满分值
        fifth_total4: "", //二模必考五科总分
        fifth_rank4: "", //二模必考五科学校排名
        inner_rank4: "", //二模区排名
        inner_subject4: "", //二模参与区排名科目
        inner_rank_total4: "", //二模参与区排名总分
        // 其他材料
        otherDesc1: "", //用三个关键词评价自己
        otherDesc2: "",
        otherDesc3: "",
        otherDesc4: "",
        otherDesc5: "",
        otherDesc6: "",
        otherDesc7: "",
        otherDesc8: "",
        otherDesc9: "",
        //业务字段
        applicationId: "",
        applicantToken: "",
        fillFormSn: "",
        operationType: "",
        schoolRecordCityCopy: "",
        eduId: "",
      },
      photoPreview: null,
      photoDialogVisible: false,
      photoLoading: false,
      labelWidth: "170px",
      // 户籍所在地列表
      cityList: [
        {
          value: "110101",
          label: "东城区",
        },
        {
          value: "110102",
          label: "西城区",
        },
        {
          value: "110105",
          label: "朝阳区",
        },
        {
          value: "110108",
          label: "海淀区",
        },
        {
          value: "110106",
          label: "丰台区",
        },
        {
          value: "110107",
          label: "石景山区",
        },

        {
          value: "110109",
          label: "门头沟区",
        },
        {
          value: "110111",
          label: "房山区",
        },
        {
          value: "110112",
          label: "通州区",
        },
        {
          value: "110113",
          label: "顺义区",
        },
        {
          value: "110114",
          label: "昌平区",
        },
        {
          value: "110115",
          label: "大兴区",
        },
        {
          value: "110116",
          label: "怀柔区",
        },
        {
          value: "110117",
          label: "平谷区",
        },
        {
          value: "110228",
          label: "密云区",
        },
        {
          value: "110229",
          label: "延庆区",
        },
        {
          value: "110230",
          label: "其他",
        },
      ],
    };
  },
  watch: {
    'form.customId': {
      handler: function (newVal) {
        this.form.eduId = newVal;
      },
    },
    // 监听相关字段变化，实时更新第四总分
    'form.chinese': 'calculateTotal',
    'form.math': 'calculateTotal',
    'form.english': 'calculateTotal',
    'form.physics': 'calculateTotal',
    'form.politics': 'calculateTotal',
    // 监听相关字段变化，实时更新第五总分
    'form.chinese1': 'calculateTotal1',
    'form.math1': 'calculateTotal1',
    'form.english1': 'calculateTotal1',
    'form.physics1': 'calculateTotal1',
    'form.politics1': 'calculateTotal1',
    // 监听相关字段变化，实时更新第五总分
    'form.chinese2': 'calculateTotal2',
    'form.math2': 'calculateTotal2',
    'form.english2': 'calculateTotal2',
    'form.physics2': 'calculateTotal2',
    'form.politics2': 'calculateTotal2',
    // 监听相关字段变化，实时更新第五总分
    'form.chinese3': 'calculateTotal3',
    'form.math3': 'calculateTotal3',
    'form.english3': 'calculateTotal3',
    'form.physics3': 'calculateTotal3',
    'form.politics3': 'calculateTotal3',
    // 监听相关字段变化，实时更新第五总分
    'form.chinese4': 'calculateTotal4',
    'form.math4': 'calculateTotal4',
    'form.english4': 'calculateTotal4',
    'form.physics4': 'calculateTotal4',
    'form.politics4': 'calculateTotal4',
  },
  methods: {
    // 自动计算必考四科总分
    calculateTotal() {
      const {chinese, math, english, physics, politics} = this.form;
      // 总分 = 语文 + 数学 + 英语 + 物理
      this.form.fifth_total = Number(chinese || 0) + Number(math || 0) + Number(english || 0) + Number(physics || 0) + Number(politics || 0);
    },
    // 自动计算必考四科总分
    calculateTotal1() {
      const {chinese1, math1, english1, physics1, politics1} = this.form;
      // 总分 = 语文 + 数学 + 英语 + 物理 + 道德
      this.form.fifth_total1 = Number(chinese1 || 0) + Number(math1 || 0) + Number(english1 || 0) + Number(physics1 || 0) + Number(politics1 || 0);
    },
    // 自动计算必考四科总分
    calculateTotal2() {
      const {chinese2, math2, english2, physics2, politics2} = this.form;
      // 总分 = 语文 + 数学 + 英语 + 物理 + 道德
      this.form.fifth_total2 = Number(chinese2 || 0) + Number(math2 || 0) + Number(english2 || 0) + Number(physics2 || 0) + Number(politics2 || 0);
    },
    // 自动计算必考四科总分
    calculateTotal3() {
      const {chinese3, math3, english3, physics3, politics3} = this.form;
      // 总分 = 语文 + 数学 + 英语 + 物理 + 道德
      this.form.fifth_total3 = Number(chinese3 || 0) + Number(math3 || 0) + Number(english3 || 0) + Number(physics3 || 0) + Number(politics3 || 0);
    },
    calculateTotal4() {
      const {chinese4, math4, english4, physics4, politics4} = this.form;
      // 总分 = 语文 + 数学 + 英语 + 物理 + 道德
      this.form.fifth_total4 = Number(chinese4 || 0) + Number(math4 || 0) + Number(english4 || 0) + Number(physics4 || 0) + Number(politics4 || 0);
    },
    // 获取填报单
    getApplication() {
      const params = {
        applicationId: this.$route.query.applicationId,
        applicantToken: this.$route.query.applicantToken,
      };
      this.$axios
        .get(
          `/galaxy/baoming/api/v1/huaxia/applicant/getApplicationInfo?${Qs.stringify(
            params
          )}`
        )
        .then((result) => {
          const res = result.data;
          if (result.code === "1000000" && res && JSON.stringify(res) !== "{}") {
            if (res.fillFormSn) {
              this.form.fillFormSn = res.fillFormSn;
            } else {
              this.getFillFormSn();
            }
            // 判断是否能修改
            if (Number(this.$route.query.fillEnable) === 1) {
              if (res.updateEnableFlag === 1) {
                this.disabledForm = false;
              } else if (res.updateEnableFlag === 0) {
                this.disabledForm = true;
              }
            } else if (Number(this.$route.query.fillEnable) === 0) {
              this.disabledForm = true;
            }
            // 判断是否被录取
            if (res.showResult) {
              this.resultDialog = true;
              this.dealState = res.dealState;
            }
            const domain = "https://" + (res.bucketDomainName || "");

            this.form = res;

            this.form.applicationId = this.$route.query.applicationId;
            this.form.applicantToken = this.$route.query.applicantToken;

            if (this.$route.query.applicationId) {
              this.form.operationType = "update";
            } else {
              this.form.operationType = "save";
            }

            this.photoPreview = res.photo
              ? domain + res.photo + "?x-oss-process=style/preview"
              : "";
          }
        });
    },
    // 新申请填报,获取串号
    getFillFormSn() {
      this.$axios
        .get(`/galaxy/baoming/api/v1/huaxia/applicant/getFillFormSn`)
        .then((result) => {
          const res = result.data;
          if (result.code === "1000000" && res && JSON.stringify(res) !== "{}") {
            this.form.fillFormSn = res.fillFormSn;
          } else {
            this.form.fillFormSn = "";
          }
        });
    },
    getLabelCity(list, val) {
      if (!val) {
        return;
      }
      let item = (list ?? [])?.filter((item) => item.value === val);
      return item?.[0]?.label;
    },

    // 提交表单
    submitForm(formName) {
      this.form.schoolRecordCityCopy = this.getLabelCity(
        this.cityList,
        this.form.schoolRecordCity
      );
      const that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          MessageBox.confirm("执行提交后，将无法修改，是否确定要提交？", "提交", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }).then(() => {
            if (
              that.form.schoolRecordCity === "110230" &&
              !that.form.schoolRecordCityOtherName.trim()
            ) {
              Message({
                type: "warning",
                message: "信息填写不完整",
                duration: 800,
              });
              return false;
            }
            if (that.form.schoolRecordCity !== "110230") {
              that.form.schoolRecordCityOtherName = "";
            }
            delete that.form.updateEnableFlag;
            that.$axios
              .post(
                "/galaxy/baoming/api/v1/huaxia/applicant/submitApplication",
                that.form
              )
              .then((result) => {
                const res = result.data;
                if (result.code === "1000000" && res) {
                  Message({
                    type: "success",
                    message: "提交成功",
                    duration: 800,
                    onClose() {
                      that.$router.push({
                        path: "/success",
                        query: {
                          applicationId: res,
                          applicantToken: that.$route.query.applicantToken,
                          batchState: that.$route.query.batchState,
                          fillEnable: that.$route.query.fillEnable,
                        },
                      });
                    },
                  });
                }
              });
          });

        } else {
          Message({
            type: "warning",
            message: "请根据上方红色提示，将个人信息填写完整",
            duration: 1500,
          });
        }
      });

    },
    // 保存表单
    saveForm() {
      if (this.form.schoolRecordCity !== "110230") {
        this.form.schoolRecordCityOtherName = "";
      }
      this.form.schoolRecordCityCopy = this.getLabelCity(
        this.cityList,
        this.form.schoolRecordCity
      );
      this.$axios
        .post("/galaxy/baoming/api/v1/huaxia/applicant/saveApplication", this.form)
        .then((result) => {
          const res = result.data;
          if (result.code === "1000000" && res) {
            const query = {
              applicationId: res,
              applicantToken: this.$route.query.applicantToken,
              batchState: this.$route.query.batchState,
              fillEnable: this.$route.query.fillEnable,
            };
            Message({
              type: "success",
              message: "保存成功",
              duration: 1000,
              onClose() {
                window.location.href =
                  window.location.origin +
                  window.location.pathname +
                  "?" +
                  Qs.stringify(query);
              },
            });
          }
        });
    },
    // 删除个人证件照
    deletePhoto() {
      this.$refs.photo.uploadFiles.splice(0, 1);
      this.form.photo = "";
      this.photoPreview = "";
    },
    // 个人证件照上传
    photoBeforeUpload(file) {
      const isJPG = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!(isJPG || isPNG || isJPEG)) {
        Message({
          type: "error",
          message: "上传文件类型格式错误!",
          duration: 1000,
        });
        return false;
      }
      if (!isLt5M) {
        Message({
          type: "error",
          message: "上传图片大小不能超过5MB!",
          duration: 1000,
        });
        return false;
      }
    },
    photoUpload(content) {
      const file = content.file;
      this.photoLoading = true;
      this.axios
        .get(
          "/galaxy/baoming/api/v1/huaxia/applicant/getUploadAuthentication?type=idphoto&fillFormSn=" +
          this.form.fillFormSn
        )
        .then(async (result) => {
          console.log(result, 'result')
          const res = result.data;
          if (result.code === "1000000" && res && JSON.stringify(res) !== "{}") {
            const params = result.data;
            params.file = file;
            const url = params.host;
            const data = await this.$store.dispatch("setUploadParams", params);
            this.$store
              .dispatch("uploadFile", {url, data})
              .then((res) => {
                this.photoLoading = false;
                if (res.status === 200) {
                  this.form.photo = `/${params.dir}/${params.file.name}`;
                  this.photoPreview =
                    url +
                    `/${params.dir}/${params.file.name}` +
                    "?x-oss-process=style/preview";

                  this.modelAnalysisPath = url + `/${params.dir}/${params.file.name}`;
                  Message({
                    type: "success",
                    message: "上传成功",
                    duration: 800,
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
    },
  },
  created() {
    if (this.$route.query.batchState === "prepared") {
      MessageBox("学生信息采集暂未开始", "未开始", {
        confirmButtonText: "确定",
      });
    } else if (this.$route.query.batchState === "closed") {
      MessageBox("学生信息采集已结束", "已结束", {confirmButtonText: "确定"});
    }

    this.form.applicationId = this.$route.query.applicationId;
    this.form.applicantToken = this.$route.query.applicantToken;
    if (this.$route.query.applicationId) {
      this.form.operationType = "update";
      this.getApplication();
    } else {
      this.form.operationType = "save";
      this.getFillFormSn();
    }
  },
};
</script>
<style lang="scss" scoped>
.resultDialog .el-dialog {
  width: 74%;
  text-align: center;

  .rejectResult {
    font-size: 22px;
  }

  .el-dialog__header {
    text-align: left;
  }

  .resultDialog_tip {
    font-size: 16px;
  }

  .resultDialog_test {
    border: 1px dotted #ccc;
    padding: 10px 16px;
  }

  .resultDialog_test_title {
    font-size: 18px;
  }

  .resultDialog_test_content {
    text-align: left;

    .resultDialog_test_item_title {
      font-size: 14px;
      font-weight: bold;
    }
  }

  .resultDialog_ask {
    text-align: left;
    color: #888;
  }

  div {
    line-height: 40px;
  }

  .link {
    color: #1890ff;
  }
}

.personalMessage {

  /deep/ .el-input-number__decrease,
  /deep/ .el-input-number__increase {
    height: calc(100% - 2px) !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-input-number {
    width: auto !important;
  }

  width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  color: rgba($color: #000000, $alpha: 0.85);

  .personalMessage_header {
    height: 125px;
    background-image: url("../assets/imgs/header.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .personalMessage_header_left {
      display: flex;
      justify-content: space-between;

      .personalMessage_schoolIcon {
        padding-left: 10px;
      }

      .personalMessage_systemName {
        display: inline-block;
        font-size: 25px;
        line-height: 81px;
        margin-left: 16px;
        font-weight: bold;
        color: rgba($color: #000000, $alpha: 0.85);
      }
    }
  }

  .personalMessage_description {
    margin-bottom: 6px;
    font-size: 14px;

    .personalMessage_description_title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }
  }

  .personalMessage_content {
    background-color: #fff;
    padding-bottom: 20px;

    .form_title {
      color: #333;
      font-size: 25px;
      text-align: center;
      padding-top: 30px;
    }

    .personalMessage_content_tips {
      padding: 0 40px;
      color: gray;
      font-size: 12px;
    }

    .personalMessage_content_maintitle {
      padding: 15px 0;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: rgba($color: #000000, $alpha: 0.85);
    }

    .classTitle {
      margin: 12px 0;
      font-size: 14px;
    }

    .personalMessage_content_module {
      padding: 12px 40px;

      .moduleDesc {
        font-size: 12px;
      }

      .wordShow {
        text-align: center;
        font-size: 16px;
        position: relative;

        img {
          position: absolute;
          top: 6px;
          left: 20px;
        }
      }

      .personalMessage_content_info {
        padding: 0 10px;
        color: gray;
        font-size: 12px;
        font-weight: 400;
      }

      .personalMessage_content_title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .personalMessage_content_title_min {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .personalMessage_content_title_required {
        position: relative;
        font-weight: normal;

        &::before {
          content: "*";
          font-size: 12px;
          position: absolute;
          top: 0px;
          left: -12px;
          color: #f56c6c;
        }
      }

      .personalMessage_content_tableList {
        .personalMessage_content_tableList_header {
          padding: 0 10px;
          background-color: #1890ff;
          display: flex;
          color: #fff;

          .personalMessage_content_tableList_header_item {
            height: 54px;
            line-height: 54px;
            text-align: left;
          }
        }

        .personalMessage_content_tableList_data {
          display: flex;
          padding: 0 10px;
          margin-top: 10px;

          .personalMessage_content_tableList_data_item {
            line-height: 40px;

            .personalMessage_content_tableList_data_item_cell {
              height: 60px;
            }
          }
        }

        .table_relation {
          width: 150px;

          .el-input {
            width: 140px;
          }
        }

        .table_name {
          width: 190px;

          .el-input {
            width: 170px;
          }
        }

        .table_phone {
          width: 250px;

          .el-input {
            width: 245px;
          }
        }

        .table_workPoint {
          width: 340px;

          .el-input {
            width: 320px;
          }
        }
      }
    }
  }

  .personalMessage_content_score {
    margin-top: 24px;

    .el-input {
      width: 170px;
    }

    .el-form-item__label {
      width: 70px !important;
    }

    .el-form-item__content {
      margin-left: 70px !important;
    }
  }

  .otherDesc {
    padding: 0 40px;

    p {
      font-weight: bold;

      &::before {
        content: "*";
        font-size: 12px;
        top: 0px;
        left: -12px;
        color: #f56c6c;
      }
    }

    .discuss {
      font-weight: 400;

      &::before {
        content: "";
      }
    }

    .six {
      margin-bottom: 4px;
    }
  }
}

.redstyle {
  color: #f5222d;
}
</style>
<style lang="scss">
.personalMessage_content_module {
  .personalMessage_content_module_message {
    .personalMessage_content_table {
      .el-table--enable-row-transition {
        .el-table__body-wrapper {
          .el-table__row {
            .el-table__cell {
              padding: 18px 0;
            }
          }
        }

        .personalMessage_content_table_score,
        .personalMessage_content_table_score_max {
          margin-left: 25px;

          &::before {
            content: "*";
            font-size: 12px;
            top: 0px;
            left: -12px;
            color: #f56c6c;
          }
        }

        .personalMessage_content_table_score_not_mandatory {
          padding-bottom: 16px;
          margin-left: 25px;
        }

        .personalMessage_content_table_score_max_not_mandatory {
          margin-left: 25px;
        }

        .personalMessage_content_table_score {
          padding-bottom: 32px;
        }
      }

      .el-table__header {
        .el-table__cell {
          font-weight: bold;
        }
      }
    }

    .personalMessage_content_table_score_total {

      .personalMessage_content_table_score_total_first,
      .personalMessage_content_table_score_total_second,
      .personalMessage_content_table_score_total_third {
        padding: 0 30px !important;

        .el-form-item {
          margin: 18px 0;

          .el-form-item__label {
            width: 150px !important;
            text-align: right;
          }

          .el-form-item__content {
            margin-left: 150px !important;
          }

          .el-input {
            width: 100%;
          }
        }
      }

      .el-row {
        margin-left: -50px !important;
        margin-right: -20px !important;
      }
    }
  }
}

.first-table {
  thead {
    tr {
      th {

        &:nth-of-type(1),
        &:nth-of-type(2),
        &:nth-of-type(3),
        &:nth-of-type(4),
        &:nth-of-type(5),
        &:nth-of-type(6),
        &:nth-of-type(7),
        &:nth-of-type(8) {
          position: relative;

          .cell {
            padding-left: 20px !important;
          }
        }
      }
    }
  }
}

.personalMessage {
  .el-table {
    margin-top: 8px;

    th {
      background-color: #fafafa;
      padding: 15px 0;
    }

    .cell {
      overflow: visible;
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .el-input {
      width: 100% !important;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .highestRank {
    position: relative;

    .el-form-item {
      display: block !important;
    }

    .el-form-item__label {
      display: block !important;
      width: 100% !important;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      display: block !important;
      width: 100%;
    }

    .el-checkbox-group {
      margin-top: 20px;
    }

    .el-checkbox {
      width: 100%;
    }

    .highestRankTime {
      .highestRankTime_input {
        height: 46px;
      }
    }
  }

  .upload_container {
    display: inline-block;
  }

  .el-dialog {
    margin-top: 2vh !important;
  }

  .el-icon-video-camera-solid {
    font-size: 24px;
    color: #000;
    margin-right: 6px;
  }

  .el-icon-zoom-in,
  .el-icon-delete {
    font-size: 30px;
    color: #fff;
    margin: 0 6px;
    cursor: pointer;
  }

  .el-icon-success {
    font-size: 18px;
    color: #52c41a;
    margin-right: 6px;
  }

  .el-input__icon {
    height: auto;
  }

  .el-date-editor {
    i {
      line-height: 32px !important;
    }
  }

  .personalMessage_header_right .el-button {
    border-radius: 0;
    background-color: #1890ff;
    width: 96px;
    height: 40px;
  }

  .el-form-item__label {
    font-size: 14px;
    color: rgba($color: #000000, $alpha: 0.85);
  }

  .el-select {
    width: 328px;
  }

  .el-input {
    width: 328px;
    height: 32px;
    line-height: 32px;

    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }

  .table_relationship {
    width: 170px;

    .el-select {
      width: 160px;

      .el-input {
        width: 150px !important;
      }
    }
  }

  .schoolRecordCity {
    .el-select {
      width: 160px;

      .el-input {
        width: 160px;
      }
    }
  }

  .personalPhoto {
    .el-form-item__label {
      width: 100% !important;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      position: relative;
      height: 200px;

      .photoPreview {
        width: 124px;
        height: 155px;
        border-radius: 6px;
        border: 1px solid #c0ccda;
        position: absolute;
        top: 40px;
        overflow: hidden;
        left: 0px;

        &:hover {
          .photoPreview_modal {
            display: block;
          }
        }

        .photoPreview_modal {
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 155px;
          position: absolute;
          top: 0;
          display: none;
          left: 0;
          background-color: rgba($color: #000000, $alpha: 0.75);
        }
      }
    }

    .el-upload {
      padding-top: 50px;
      width: 124px;
      height: 155px;
      line-height: 30px;
    }

    .el-loading-mask {
      width: 124px;
      height: 155px;
    }

    .el-upload-list__item {
      width: 124px;
      height: 155px;
    }

    .el-upload__tip {
      line-height: 22px;
      color: rgba($color: #000000, $alpha: 0.45);
      font-size: 14px;
      margin-top: -106px;
      margin-left: 168px;
    }
  }

  .schoolRecordCityOtherName {
    margin-left: 8px;
    position: relative;

    .el-form-item__content {
      margin-left: 0 !important;
    }

    .el-input {
      width: 160px;
    }
  }

  .personalMessage_content_tableList {
    .el-form-item {
      margin-bottom: 0;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }

    .el-form-item__label {
      width: 0 !important;
    }
  }

  .formFooter {
    padding: 20px 0 0;

    .el-form-item__content {
      margin-left: 40px !important;
    }
  }

  .purple {
    background-color: #1890ff !important;
    border-color: #1890ff !important;

    &:hover {
      background-color: #1890ff;
      border-color: #1890ff;
      color: #fff;
    }
  }

  .default:hover {
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
  }

  .academicExamination {
    display: flex;
    justify-content: left;
    height: 35px;

    .el-form-item {
      .el-form-item__label {
        width: 140px !important;
        text-align: right;
      }

      .el-form-item__content {
        margin-left: 140px !important;
      }

      .el-input {
        width: 200px;
      }
    }
  }
}
</style>
